export enum LocationType {
    Remote = "Remote",
    OnSite = "OnSite",
    Hybrid = "Hybrid",
}